var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticStyle:{"margin-bottom":"10px"}},[(_vm.isShowHeader)?_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"border-left"}),_vm._t("card-header")],2)]):_vm._e(),_vm._t("card-body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }